import { useAuth0Data } from 'neon-auth0';
import { useEffect, useState } from 'react';
import { config } from '../../config';

// Hook to create a URL for resources that require authorization tokens

export const useSecureFileUrl = (path: string) => {
	const [objectUrl, setObjectUrl] = useState<string | undefined>();
	const { accessToken } = useAuth0Data();

	useEffect(() => {
		fetch(config.serverUrl + path, { headers: { Authorization: 'Bearer ' + accessToken } })
			.then(result => result.blob())
			.then(blob => setObjectUrl(blob.size ? URL.createObjectURL(blob) : undefined));

		return () => {
			objectUrl && URL.revokeObjectURL(objectUrl);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [path, accessToken]);

	return objectUrl;
}
